// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3kQNG","rootSmall":"AddTileButton_rootSmall__2KygE"};